// Rewrites ```chart fenced code blocks into a <chart spec="<raw json>"> element.
// mdast-util-to-hast's applyData honors data.hName/hProperties/hChildren on any
// node, including `code`, so the default <pre><code> output is replaced.
interface MdNode {
  type: string;
  lang?: string;
  value?: string;
  children?: MdNode[];
  data?: Record<string, unknown>;
}

function walk(node: MdNode, visit: (n: MdNode) => void) {
  visit(node);
  node.children?.forEach((c) => walk(c, visit));
}

export function remarkChart() {
  return (tree: MdNode) => {
    walk(tree, (node) => {
      if (node.type !== "code" || node.lang !== "chart") return;
      node.data = {
        ...(node.data ?? {}),
        hName: "chart",
        hProperties: { spec: node.value ?? "" },
        hChildren: [],
      };
    });
  };
}
